import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.cashierCancelPage.setFetching(isFetching)


const fetch = (date) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.cashierCancelList + `/${tool}?date=${date}`)
    .then(({ data }) => data)
    .then((cancelList) => reducers.marketplace.cashierCancelPage.setCancelList(cancelList))
    .catch(() => {
      reducers.marketplace.cashierCancelPage.setCancelList([
        {
          id: 1,
          ticket: 'jn1k23',
          amount: '100',
        },
        {
          id: 2,
          ticket: 'jn1k33',
          amount: '300',
        },
        {
          id: 3,
          ticket: 'xn1k45',
          amount: '200',
        },
      ])
    })
}

const setCancelListItem = (ticketId) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.cashierCancelList + `/${tool}`, { ticketId })
    .then(({ data }) => data)
}


export default {
  setFetching,
  fetch,
  setCancelListItem,
}
